import { useState } from 'react';
import type { AnnouncementModule } from '@inboundhost/shared';

interface Props {
  value: AnnouncementModule | null;
  onSave: (v: AnnouncementModule) => void;
}

const EMPTY: AnnouncementModule = { enabled: false, message: '', variant: 'info' };

export function AnnouncementEditor({ value, onSave }: Props) {
  const [data, setData] = useState<AnnouncementModule>(value ?? EMPTY);

  return (
    <div className="bg-white rounded shadow p-6 space-y-4">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={data.enabled}
          onChange={(e) => setData({ ...data, enabled: e.target.checked })}
        />
        <span className="text-sm font-medium">Show announcement banner</span>
      </label>

      <label className="block">
        <span className="text-sm font-medium">Title (optional)</span>
        <input
          className="mt-1 w-full border rounded px-3 py-2"
          value={data.title ?? ''}
          onChange={(e) => setData({ ...data, title: e.target.value })}
        />
      </label>

      <label className="block">
        <span className="text-sm font-medium">Message</span>
        <textarea
          className="mt-1 w-full border rounded px-3 py-2"
          rows={2}
          value={data.message}
          onChange={(e) => setData({ ...data, message: e.target.value })}
        />
      </label>

      <label className="block">
        <span className="text-sm font-medium">Variant</span>
        <select
          className="mt-1 border rounded px-3 py-2"
          value={data.variant ?? 'info'}
          onChange={(e) => setData({ ...data, variant: e.target.value as 'info' | 'warning' | 'success' })}
        >
          <option value="info">Info</option>
          <option value="warning">Warning</option>
          <option value="success">Success</option>
        </select>
      </label>

      <button
        type="button"
        onClick={() => onSave(data)}
        className="bg-gray-900 text-white px-4 py-1 rounded hover:bg-gray-800"
      >
        Save announcement
      </button>
    </div>
  );
}
